export const digitalSolutions = {
  subtitle:
    'Цифрові рішення – напрям розвитку медицини в усьому світі. Адже саме вони допомагають подолати такі проблеми як розрізненість медичної інформації, брак часу на навчання та розвиток лікарів, покращують рівень обізнаності пацієнтів та сприяють кращій прихильності до лікування.  Компанія Сервє, як лідер інновацій в кардіології, представляє сучасні цифрові рішення, які будуть слугувати на користь  лікарям та пацієнтам в Україні. ',
  digitalForDoctors: {
    title: 'Цифрові рішення для лікарів',
    subtitle: 'Медичний додаток “Компендіум Servier”',
    p1:
      'Додаток “Компендіум Servier” призначений для того, щоб полегшити роботу лікаря та зекономити його час. Зокрема, додаток містить:',
    ul: [
      'довідник лікарських засобів, включаючи показання, спосіб застосування, дозування, актуальну інформацію про ціну і наявність необхідного препарату у найближчих аптеках;',
      '20 актуальних медичних калькуляторів для розрахунку показників. Зокрема, такі популярні калькулятори як розрахунок ШКФ (швидкість клубочкової фільтрації), ІМТ (індексу маси тіла), SCORE (сумарного ризику смерті від серцево-судинних захворювань у найближчі 10 років).',
      'норми лабораторних та інструментальних показників;',
      'контакти лікувальних закладів України;',
      'класифікації МКБ 10 та ICPC 2',
      'посилання на актуальні протоколи МОЗ;',
      'відеозаписи вебінарів;',
      'корисні матеріали, якими можна ділитися з пацієнтами.',
    ],
    p2: 'уже використовують понад 4 тис. лікарів України.',
    p3: 'Детальний огляд застосунку доступний у  ',
    p4: 'Завантажити додаток можна безкоштовно:',
    p5:
      'Для користування додатком необхідно авторизуватися. Для цього потрібно заповнити дані та запитати токен. Після отримання токену, необхідно ввести його та підтвердити умови використання умови використання додатком.\n',
    a1: 'Google Play  для Android. ',
    a2: 'App Store  для IOS.',
    token1a: 'Якщо ви бажаєте використовувати додаток з',
    token1b: ' доступна web-версія за ',
    token2: '- Якщо ви вже користуєтесь застосунком: \n',
    token3:
      'Увійдіть, використовуючи токен із застосунка, який можна знайти в розділі основного меню “Мій токен” .\n',
    token4: '- Якщо ви ще не користуєтесь застосунком:',
    token5: 'Натисніть на поле “Запитати токен”\n',
    token6:
      'Використання додатку не замінює необхідність відвідування лікаря, який є кваліфікованим фахівцем, що має право поставити діагноз і скласти рекомендації відповідно до стану здоров’я користувача додатком. Не слід сприймати інформацію, яка міститься в додатку, як медичну пораду і тлумачити її як медичну рекомендацію. Додаток не є інструментом діагностики і не призначений для терапевтичного застосування. Copyright © 2021. ТОВ « Серв’є Україна ». Всі права захищені. ',
  },
  telegram: {
    title: 'Освітній канал “Кардіопростір”',
    p1:
      'Також запрошуємо Вас приєднуватися до нашого Телеграм каналу – Кардіопростір. \n',
    p2:
      '\n' +
      'На каналі доступний цікавий медичний контент з кардіології: актуальні новини, анонси подій, останні дослідження, цифрові рішення, корисні матеріали, якими можна поділитися з пацієнтами та замовити в друкованому вигляді — все на допомогу практикуючому лікарю. \n',
    p3:
      'Ціль каналу — допомогти українським лікарям бути готовими до сучасних викликів професії. На каналі доступний цікавий медичний контент з кардіології: актуальні новини, анонси подій, цифрові рішення, корисні матеріали — все на допомогу практикуючому лікарю.',
    p4: ' призначений виключно для спеціалістів галузі охорони здоров’я. \n',
    p5: 'Аби приєднатися до каналу, перейдіть за посиланням.',
  },
  digitalForVisitors: {
    title: 'Цифрові рішення для пацієнтів',
    subtitle1:
      'Додаток для пацієнтів з гіпертензією “Мій контроль тиску” (My BP control)',
    p1:
      'Додаток "Мій контроль тиску" розроблений для того, аби допомогти пацієнтам вчасно приймати ліки, тим самим значно покращити ефективність терапії та зекономити час на збір анамнезу.\n',
    ul1: [
      ' Встановити нагадування про прийом необхідних ліків у потрібний час.\n',
      'Вносити показники артеріального тиску і пульсу в електронний щоденник.\n',
      'Побудувати звіт за своїми показниками та надіслати його лікарю на пошту. Такий формат допомагає лікарям дистанційно приймати терапевтичні рішення, у тому числі під час пандемії.   \n',
    ],
    p2:
      'У сучасному світі все більше пацієнтів віддають перевагу не паперовим щоденникам для контролю тиску, а медичним додаткам. Так, додатком “Мій контроль тиску” уже  користуються понад 4 тисячі пацієнтів.\n',
    p3: 'Детальний огляд застосунку доступний у\n',
    p12: 'У додатку пацієнт може:',
    p13: 'Завантажити додаток можна безкоштовно:\n',
    p14: 'Google Play для Android. \n',
    p15: 'App Store для IOS.\n',
    p16:
      'Використання додатку не замінює необхідність відвідування лікаря, який є кваліфікованим фахівцем, що має право поставити діагноз і скласти рекомендації відповідно до стану здоров’я користувача додатком. Не слід сприймати інформацію, яка міститься в додатку, як медичну пораду і тлумачити її як медичну рекомендацію. Додаток не є інструментом діагностики і не призначений для терапевтичного застосування. Copyright © 2021. ТОВ « Серв’є Україна ». Всі права захищені. \n',
    p4:
      'Додаток можна рекомендувати пацієнтам для зручного та ефективного контролю артеріального тиску. Для користування додатком не потрібно спеціальних дозволів.',
    subtitle2:
      'Додаток для пацієнтів зі стенокардією “Стенокардія під контролем” (Angina Control)',
    p5:
      'Додаток “Стенокардія під контролем” призначений для того, щоб допомогти пацієнтам відслідковувати напади стенокардії.\n' +
      '\n',
    ang1: 'В додатку пацієнт може:',
    ang2:
      'Додаток можна рекомендувати пацієнтам для зручного та ефективного контролю нападів стенокардії.\n',
    ang3:
      '\nДля користування Angina Control спеціальних дозволів не потрібно.\n',
    ul2: [
      'Відмічати дату, час, причину нападів стенокардії в електронному щоденнику. ',
      'На основі зібраних даних будувати звіти, відслідковувати ефективність лікування та свій прогрес.\n',
      'Встановити періодичне нагадування, щоб вчасно описувати умови та особливості нападів.',
    ],
    p6:
      'Крім того, лікар може віддалено спостерігати за перебігом захворювань пацієнтів за допомогою функції звітів. Зокрема, у додатку можна відслідкувати кількість та тривалість нападів, стани, у якому найчастіше стаються (у стані спокою чи після фізичного навантаження), а також кількість доз нітрогліцерину, що прийняв пацієнт за тиждень, місяць чи рік.',
    p7: 'Додаток Angina Control використовують понад 8 тисяч пацієнтів.',
    diabetesWords: {
      subtitle: 'Довідник з діабету (Diabetes words)',
      p1:
        'Довідник з діабету (Diabetes words) – це додаток для пацієнтів з цукровим дібетом 2 типу та їх родичів, щоб дізнатися більше про захворювання та бути обізнаними про спосіб життя з ним. \n',
      p2: '\nДодаток містить інформацію про:\n',
      ul1: [
        'Дієту, фізичну активність.\n',
        'Причини, симптоми та наслідки діабету 2 типу.\n',
        'Діагностику, лікування, профілактику.\n',
        'Контроль глюкози, HbA1c\n',
        'Діабет 2 типу та COVID-19.\n',
      ],
      code: 'DIG-C1-2 (2021-2023, 2 years)-54',
    },
    subtitle3:
      'Освітня сторінка для пацієнтів на сайті ННЦ “Інститут кардіології імені академіка М.Д. Стражеска”\n',
    p8:
      'На сайті ННЦ“Інститут кардіології імені академіка М.Д. Стражеска” працює освітня сторінка для пацієнтів, розроблена  за інформаційної підтримки компанії Servier. Сторінка призначена для того, щоб надати пацієнтам із серцево-судинними захворюваннями надійну та перевірену освітню інформацію про їхні хвороби. \n',
    p9:
      'Користувачі можуть ознайомитися з освітніми відео та рекомендаціями щодо дієти, фізичної активності та здорового способу життя. Також пацієнтам доступні й інші корисні матеріали, наприклад, як правильно вимірювати тиск чи як розпізнати інфаркт та інсульт. \n',
    p10:
      'На сторінці є детальна інформація про мобільні додатки для полегшення процесу лікування пацієнтам з гіпертензією – “Мій контроль тиску” та стенокардією – “Контроль стенокардії” \n',
    p11:
      'Сторінка – це частина освітнього проєкту, в межах якого функціонує і навчальний кабінет в поліклініці Інституту. У ньому пацієнти можуть отримати більше інформації про серцево-судинні захворювання, зміну способу життя та навчитися правильно вимірювати тиск і пульс на практиці з допомогою медичного працівника. \n',
    p17:
      'Ідея всього проєкту виникла як відповідь на результати останніх наукових досліджень, що підтверджують ефективність навчання пацієнтів та доводять зв’язок між дотриманням пацієнтом рекомендацій лікаря та запобігання життєво небезпечних ускладнень серцево-судинних захворювань. Зокрема, вимірювання ефективності освітніх кабінетів у США показали, що прихильність пацієнтів до лікування зростала на 16%, а ризик повторної госпіталізації з приводу серцевої недостатності зменшився на 44%. \n',
    p18: 'Ознайомитися зі сторінкою можна за ',
    p19:
      'Ви можете поділитися посиланням на сторінку з вашими пацієнтами, адже це перший і єдиний офіційний ресурс для кардіологічних пацієнтів. Саме там вони зможуть знайти перевірену і якісну інформацію щодо життя з серцево-судинними захворюваннями, схвалену Асоціацією кардіологів України. \n',
    p20:
      'Джерело: Guidelines for the management of arterial hypertension. European Heart Journal (2018) 39, 3021–3104 doi:10.1093/eurheartj/ehy339\n',
    p21:
      "Джерело: Ochsner Health System's O Bar Improves Chronic Disease Management & Patient Engagement",
  },
};
